/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recognition_Top_Rated_TitleInputs */

const en_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Rated Seller`)
};

const ar_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بائع الأعلى تقييمًا`)
};

const bn_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টপ রেটেড সেলার`)
};

const de_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestbewerteter Verkäufer`)
};

const es_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor mejor calificado`)
};

const fr_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeur le mieux noté`)
};

const pt_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor mais bem avaliado`)
};

const zh_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评分最高的卖家`)
};

const tr_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok Oy Alan Satıcı`)
};

const ru_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавец с самым высоким рейтингом`)
};

const pl_recognition_top_rated_title = /** @type {(inputs: Recognition_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najwyżej oceniany sprzedawca`)
};

/**
* | output |
* | --- |
* | "Top Rated Seller" |
*
* @param {Recognition_Top_Rated_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const recognition_top_rated_title = /** @type {((inputs?: Recognition_Top_Rated_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recognition_Top_Rated_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_recognition_top_rated_title(inputs)
	if (locale === "bn") return bn_recognition_top_rated_title(inputs)
	if (locale === "de") return de_recognition_top_rated_title(inputs)
	if (locale === "es") return es_recognition_top_rated_title(inputs)
	if (locale === "fr") return fr_recognition_top_rated_title(inputs)
	if (locale === "pt") return pt_recognition_top_rated_title(inputs)
	if (locale === "zh") return zh_recognition_top_rated_title(inputs)
	if (locale === "tr") return tr_recognition_top_rated_title(inputs)
	if (locale === "ru") return ru_recognition_top_rated_title(inputs)
	if (locale === "pl") return pl_recognition_top_rated_title(inputs)
	return en_recognition_top_rated_title(inputs)
});